import React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom'
import {
  fetchCourseLmsData,
  fetchCourseLmsToken,
  fetchAssessments,
} from '../actions'
import { routePaths } from '../urls'

import Canvas from './Canvas'
import Brightspace from './Brightspace'
import Navigation from './Navigation'

class Application extends React.Component {
  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
    let { coursenum } = this.context.store.getState()
    this.context.store.dispatch(fetchCourseLmsData(coursenum))
    this.context.store.dispatch(fetchCourseLmsToken(coursenum))
    this.context.store.dispatch(fetchAssessments(coursenum))
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    let { selectedLms } = this.context.store.getState()
    let redirectPath

    // actions.js define the magic strings that are frontend safe
    switch (selectedLms) {
      case 'canvas_v2':
        redirectPath = routePaths.canvas
        break
      case 'brightspace':
        redirectPath = routePaths.brightspace
        break
    }

    return (
      <Router>
        <div
          id="body_section"
          className="row opacity-0 position-relative p-0 m-5"
        >
          <h2 className="me-page-title mt-5">LMS Integration</h2>
          <section id="body_section_left_column" className="col-md-6 pl-0 mt-5">
            <Navigation />
          </section>

          <section id="body_section_center" className="mt-3 pt-3 col-md-18">
            <Route
              exact
              path={routePaths.root}
              render={() => <Redirect to={redirectPath} />}
            />
            <Route path={routePaths.canvas} component={Canvas} />
            <Route path={routePaths.brightspace} component={Brightspace} />
          </section>
        </div>
      </Router>
    )
  }
}

Application.propTypes = {
  storeState: PropTypes.object,
}

Application.contextTypes = {
  store: PropTypes.object,
}

export default Application
